import PropTypes from "prop-types";
import noop from "lodash/noop";
import { Link } from "react-router-dom";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export const LinkContainer = ({
  children,
  isActive,
  onClick = noop,
  ...props
}) => (
  <Link
    onClick={onClick}
    className={classNames(
      "text-dark bg-primary flex cursor-pointer items-start justify-between gap-4 px-5 py-2.5 transition-colors focus:outline-none",
      {
        "bg-tertiary": isActive,
      },
    )}
    {...props}
  >
    {children}
  </Link>
);

LinkContainer.propTypes = {
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};
